<template>
  <transition name="fade">
    <div
      v-if="!loading"
      id="app"
      :key="key"
      :class="{ 'mobile-view': mobile_view }"
    >
      <router-view
        ref="header"
        name="header"
        @refresh="refresh"
      />
      <main>
        <!-- <transition name="fade"> -->
        <router-view />
        <!-- </transition> -->
      </main>
      <router-view
        ref="footer"
        v-view.once
        name="footer"
        class="animated fadeIn"
        @refresh="refresh"
      />
    </div>
  </transition>
</template>
<style src='./assets/css/animate.min.css'></style>
<style src='./assets/css/font-awesome.min.css'></style>
<style lang="scss" src="./assets/scss/style.scss"></style>

<script>
export default {
  name: "App",
  data() {
    return {
      loading: true,
      // loadingContent: false,
      mobile_view: false
    };
  },
  computed: {
    key() {
      let key = null;
      switch (this.$route.name) {
        case "list":
          key = this.$route.params.type;
          break;
        default:
          key = this.$route.path.substr(1);
          break;
      }
      return key;
    }
  },
  metaInfo() {
    let title =
      typeof this.$route.meta.title == "undefined" ||
      this.$route.meta.title == ""
        ? ""
        : this.$route.meta.title + " | ";

    title +=
      this.$t("app_title") + " | Jointly organized by SCMP and RTHK | SCMP.com";

    let desc =
      !this.$route.meta.desc || this.$route.meta.desc == ""
        ? localStorage.locale == "en"
          ? this.$config.app_desc
          : this.$config.app_desc_cht
        : this.$route.meta.desc;
    return {
      title: title,
      meta: [
        {
          content: title,
          property: "og:title",
          vmid: "og:title"
        },
        {
          property: "description",
          content: desc,
          vmid: "description"
        },
        {
          property: "og:description",
          content: desc,
          vmid: "og:description"
        }
      ]
    };
  },
  // created() {
  //   (function(d, s, id) {
  //     var js,
  //       fjs = d.getElementsByTagName(s)[0];
  //     if (d.getElementById(id)) {
  //       return;
  //     }
  //     js = d.createElement(s);
  //     js.id = id;
  //     js.src = "https://connect.facebook.net/en_US/sdk.js";
  //     fjs.parentNode.insertBefore(js, fjs);
  //   })(document, "script", "facebook-jssdk");
  // },
  mounted() {
    console.log(process.env.NODE_ENV);
    this.init();
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      if (
        document.documentElement.clientWidth > this.$config.breakpoints.main
      ) {
        this.mobile_view = false;
      } else {
        this.mobile_view = true;
      }

      // let __this = this;
      // setTimeout(() => {
      //   let headerComp = this.$refs.header;
      //   let footerComp = this.$refs.footer;
      //   headerComp.mobile_view = footerComp.mobile_view = this.mobile_view;
      //   headerComp.mobile_menu_open = false;

      //   if (this.mobile_view) {
      //     headerComp.mobile_submenu_open = null;
      //   } else {
      //     footerComp.loadFacebook();
      //   }
      // }, 10);
    },
    init() {
      this.$http
        .get("osc_variables")
        .then(response => {
          var osc_variables = response.data.data;
          for (var i in osc_variables) {
            localStorage.setItem(osc_variables[i].name, osc_variables[i].value);
          }
        })
        .finally(() => {
          this.loading = false;
          if (!localStorage.osc_year) {
            localStorage.osc_year = new Date().getFullYear();
          }
        });
    },
    refresh(resolve) {
      this.loading = true;
      // window.scrollTo(0, 0);
      this.$nextTick(() => {
        // location.reload(true);
        this.loading = false;
        resolve(true);
      });
    }
  }
};
</script>